import { render } from "./403.vue?vue&type=template&id=2447623b&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"

import "./403.vue?vue&type=style&index=0&id=2447623b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2447623b"]])

export default __exports__